export const DEFAULT_SEARCH_PREVIOUS_X_DAYS = 5;

export default null;
